import React from "react";

import { footer } from "./styles/Footer.module.scss";

export default function Footer () {
    return (
        <footer className={footer}>
            Developed by <a href="https://github.com/pasdo501">Dominik Paschke</a>
        </footer>
    )
}